import { SET_IMAGE_FOR_ALL_THUMB_TYPES } from './card'

const initialState = []

export default function(state = initialState, action) {
  switch (action.type) {
    case SET_IMAGE_FOR_ALL_THUMB_TYPES: {
      return [action.payload, ...state]
    }
    default:
      return state
  }
}
